import styled from 'styled-components'
import { colors } from 'Styled/variables'

export const StyledToggleSwitch = styled.div`
  .ant-switch {
    min-width: 42px;
    height: 20px;
    background-color: ${colors.greyBg};
    border: 1px solid ${colors.greyStroke};
    box-sizing: border-box;
    border-radius: 10px;
    &:focus {
      outline: none;
      box-shadow: none;
    }
    &:hover {
      outline: none;
      box-shadow: none;
    }
    &:active {
      outline: none;
      box-shadow: none;
    }
  }
  .ant-switch-handle {
    top: -3px;
    width: 24px;
    height: 24px;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.25);
    border-radius: 50%;
    &::before {
      background-color: ${colors.white};
      border-radius: 50%;
    }
  }

  .ant-switch-checked {
    background-color: ${colors.messegesGreen2};
  }

  .ant-click-animating-node {
    outline: none;
    box-shadow: none;
  }
`
